import React, { useContext, useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Link, useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import { Calendar } from "primereact/calendar";
import { Nullable } from "primereact/ts-helpers";
import "bootstrap-daterangepicker/daterangepicker.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Cookies from "js-cookie";
import { BiRefresh } from "react-icons/bi";
import { motion } from "framer-motion";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  RadialBarChart,
  RadialBar,
  PolarAngleAxis,
  CartesianGrid,
} from "recharts";
import { format } from "date-fns";
import { DateRange } from "react-date-range";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Spin } from "antd";
import { InactivityContext } from "../../academic/examinations/InactivityContext";
import { all_routes } from "../../router/all_routes";
import { useUserPermissions } from "../../UserPermissionsContext";
import AdminDashboardModal from "./adminDashboardModal";
import Counter from "../../academic/examinations/counter";

const players = [
  {
    name: "Mohan",
    score: 425,
    image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
  },
  {
    name: "Pavan",
    score: 524,
    image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
  },
  {
    name: "Ravi",
    score: 625,
    image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
  },
];

const salesData = [
  { name: "Alice", sales: 250, image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png" },
  { name: "Bob", sales: 180, image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png" },
  { name: "Charlie", sales: 300, image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png" },
  { name: "David", sales: 150, image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png" },
  { name: "Eve", sales: 220, image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png" },
];

const data = [
  { name: "Mon", Calls: 120, Connected: 80 },
  { name: "Tue", Calls: 180, Connected: 110 },
  { name: "Wed", Calls: 150, Connected: 90 },
  { name: "Thu", Calls: 200, Connected: 140 },
  { name: "Fri", Calls: 170, Connected: 100 },
  { name: "Sat", Calls: 130, Connected: 70 },
];

const leaderboardData = [
  { name: "Amelia Kerr", points: 720, position: 1 },
  { name: "Jess Kerr", points: 720, position: 2 },
  { name: "Eden Carson", points: 720, position: 3 },
];

const data5 = [
  { day: "Mon", sales: 40, connected: 80 },
  { day: "Tue", sales: 90, connected: 140 },
  { day: "Wed", sales: 70, connected: 100 },
  { day: "Thu", sales: 80, connected: 120 },
  { day: "Fri", sales: 50, connected: 90 },
  { day: "Sat", sales: 85, connected: 110 },
];

const dataL = [
  {
    profileImage: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png',
    image: '/assets/img/Vector (1).png',
    name: 'John Doe',
    saleCount: 150
  },
  {
    profileImage: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png',
    image: '/assets/img/Vector.png',
    name: 'Jane Smith',
    saleCount: 200
  },
  {
    profileImage: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png',
    image: '/assets/img/Vector (2).png',

    name: 'Mark Johnson',
    saleCount: 100
  }
];

type Dashboard = {
  id: number;
  agent_name: string;
  status_name: string;
  updated_at: string;
  last_login_time: string;
  agent: number;
  status: number;
  calls: string;
  connected: string;
  missed: string;
  interested: string;
  callbacks: string;
  sale: string;
  performance: string;
  total_ideal_time: string;
};

const topThree = [
  { name: "Ravi", score: 625, rank: 1 },
  { name: "Mohan", score: 425, rank: 2 },
  { name: "Pavan", score: 524, rank: 3 },
];

// const others = [
//     { name: "Akash", score: 3768 },
//     { name: "Papa Rao", score: 3768 },
//     { name: "Chikitha", score: 3768 },
//     { name: "Anil", score: 3768 },
//     { name: "Doopesh", score: 3768 },
// ];

interface Winner {
  name: string;
  rank: number;
  image: string;
}

const winners = [
  {
    rank: 1,
    name: "John",
    score: 4500,
    image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
  },
  {
    rank: 2,
    name: "Emma",
    score: 4200,
    image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
  },
  {
    rank: 3,
    name: "Liam",
    score: 3900,
    image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
  },
  {
    rank: 4,
    name: "Olivia",
    score: 3768,
    image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
  },
  {
    rank: 5,
    name: "Noah",
    score: 3600,
    image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
  },
  {
    rank: 6,
    name: "Sophia",
    score: 3450,
    image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
  },
  {
    rank: 1,
    name: "John",
    score: 4500,
    image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
  },
  {
    rank: 2,
    name: "Emma",
    score: 4200,
    image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
  },
  {
    rank: 3,
    name: "Liam",
    score: 3900,
    image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
  },
  {
    rank: 4,
    name: "Olivia",
    score: 3768,
    image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
  },
  {
    rank: 5,
    name: "Noah",
    score: 3600,
    image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
  },
  {
    rank: 6,
    name: "Sophia",
    score: 3450,
    image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
  },
];

const barImages = [
  '/assets/img/Vector (1).png', // Bar image 1
  '/assets/img/Vector.png', // Bar image 2
  '/assets/img/Vector (2).png', // Bar image 3
];

const profileImages = [
  'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', // Profile image 1
  'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', // Profile image 2
  'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', // Profile image 3
];

type TodayLeads = {
  total_leads: number;
  call_logs: number;
  connected_call_logs: number;
  interested: number;
  call_backs: number;
  sales: number;
  average_conversation_duration: string;
  "call/leads_per": number;
  calls_connected_per: number;
  interested_per: number;
  call_backs_per: number;
  sales_per: number;
  not_interested: number;
  not_interested_per: number;
  achieved_amount: string;
  target_amount: string;
  target_amount_per: number;
};

interface SalesData {
  rank: number;
  profilePic: string;
  name: string;
  sales: number;
}

interface Leaderboard {
  rank: number;
  id: number,
  username: string;
  sales_count: number;
  photo: string;
  sl_no: number;
}
interface CallsDaily {
  calls: number;
  connected: number,
  label: string
}

interface Data {
  Daily: SalesData[];
  Weekly: SalesData[];
  Monthly: SalesData[];
  AllTime: SalesData[];
}

const data9: Data = {
  Daily: [
    { rank: 1, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Alice', sales: 10 },
    { rank: 2, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Bob', sales: 8 },
    { rank: 3, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Charlie', sales: 5 },
  ],
  Weekly: [
    { rank: 1, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'David', sales: 50 },
    { rank: 2, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Eve', sales: 45 },
    { rank: 3, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Frank', sales: 30 },
  ],
  Monthly: [
    { rank: 1, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Grace', sales: 200 },
    { rank: 2, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Heidi', sales: 180 },
    { rank: 3, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Ivan', sales: 150 },
  ],
  AllTime: [
    { rank: 1, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Judy', sales: 1000 },
    { rank: 2, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Karl', sales: 950 },
    { rank: 3, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Leo', sales: 900 },
  ],
};

interface SalesDaily {
  label: string,
  sales: number,
}
const AdminDashboard = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const [date, setDate] = useState<Nullable<Date>>(null);
  const { userPermissions, webApi } = useUserPermissions();
  const [dashboardData, setDashboardData] = useState<Dashboard[]>([]);
  const jwtToken = Cookies.get("authToken");
  const context = useContext(InactivityContext);
  const [todayLeads, setTodayLeads] = useState<TodayLeads | null>(null);
  const [dateRangeLeads, setDateRangeLeads] = useState<TodayLeads | null>(null);
  const [todayLeadsLoading, setTodayLeadsLoading] = useState(false);
  const [leaderboard, setLeaderBoard] = useState<Leaderboard[]>([]);
  const [CallsDailyGraph, setCallsDailyGraph] = useState<CallsDaily[]>([])
  const [salesDaily, setSalesDaily] = useState<SalesDaily[]>([]);
  const [top3Wizklub, setTop3Wizlub] = useState<any[]>([]);
  const [overall, setoverall] = useState<any[]>([]);
  const sortedData = [...salesData].sort((a, b) => b.sales - a.sales);
  const maxSales = Math.max(...salesData.map((s) => s.sales));
  const [refreshIsLoading, seteRfreshIsLoading] = useState(false);
  const [salesVsConnected, setSalesVsConnected] = useState({
    total_sales: 0,
    total_connected: 0,
    sales_vs_connected_per: 0,
    results: [],
  });
  const [salesVsCallBack, setSalesVsCallBack] = useState({
    total_sales: 0,
    total_call_backs: 0,
    sales_vs_call_backs_per: 0,
    results: [],
  });
  const [salesVsIntrested, setSalesVsIntrested] = useState({
    total_sales: 0,
    total_interested: 0,
    sales_vs_interested_per: 0,
    results: [],
  });

  const [activeTab, setActiveTab] = useState<'Daily' | 'Weekly' | 'Monthly' | 'AllTime'>('Daily');
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  useEffect(() => {
    setLeaderBoard([]);
    fetchLeaderboard(tabToDays[activeTab])
  }, [activeTab]);

  const tabMapping: { [key: string]: 'Daily' | 'Weekly' | 'Monthly' | 'AllTime' } = {
    'Today': 'Daily',
    'Last 7 days': 'Weekly',
    'Last 30 days': 'Monthly',
    'AllTime': 'AllTime'
  };

  const tabToDays = {
    Daily: "today",
    Weekly: "week",
    Monthly: "month",
    AllTime: "all",
  };


  const top3 = leaderboard.slice(0, 3); // Top 3 agents
  const others = leaderboard.slice(3);
  const reorderedTop3 = [top3[1], top3[0], top3[2]].filter(Boolean);


  if (!context) {
    throw new Error("SomeComponent must be used within an InactivityProvider");
  }

  const { isIdle, isStatusChange, setIsStatusChange } = context;

  const [monitoringStatus, setMonitoringStatus] = useState<
    { id: number; name: string }[]
  >([]);

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchData = async () => {
    seteRfreshIsLoading(true); // Set loading to true
    try {
      const response = await fetch(
        `${webApi}/dashboard/summercamp_agent_monitoring/`,
        options
      );
      const data = await response.json();
      setDashboardData(data.results);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      seteRfreshIsLoading(false); // Set loading back to false after fetch is complete
    }
  };

  const fetchLeaderboard = async (days: string) => {
    const response = await fetch(
      `${webApi}/dashboard/wizklub_sales_leaderboard/?filter=${days}`,
      options
    );
    const data = await response.json();
    setLeaderBoard(data);
  };

  const fetchCalldDailyGraph = async () => {
    const response = await fetch(
      `${webApi}/dashboard/summercamp_call_graph_dashboard/`,
      options
    );
    const data = await response.json();
    setCallsDailyGraph(data);
  };

  const fetchSalesGraph = async () => {
    const response = await fetch(
      `${webApi}/dashboard/summercamp_sales_graph_dashboard/`,
      options
    );
    const data = await response.json();
    setSalesDaily(data);
  };

  const fetchSalesVsConnected = async () => {
    const response = await fetch(
      `${webApi}/dashboard/summercamp_sales_vs_connected_call_graph/`,
      options
    );
    const data = await response.json();
    setSalesVsConnected(data);
  };

  const fetchSalesVsCallBacks = async () => {
    const response = await fetch(
      `${webApi}/dashboard/summercamp_sales_vs_call_backs_graph/`,
      options
    );
    const data = await response.json();
    setSalesVsCallBack(data);
  };

  const fetchSalesvsIntrested = async () => {
    const response = await fetch(
      `${webApi}/dashboard/summercamp_sales_vs_interested_graph/`,
      options
    );
    const data = await response.json();
    setSalesVsIntrested(data);
  };

  const fetchTop3 = async () => {
    const response = await fetch(
      `${webApi}/dashboard/summercamp_today_top_three_performers/`,
      options
    );
    const data = await response.json();
    setTop3Wizlub(data);
  };

  const fetchOverall = async () => {
    const response = await fetch(
      `${webApi}/dashboard/summercamp_overall_top_three_performers/`,
      options
    );
    const data = await response.json();
    setoverall(data);
  };

  const fetchMonitoringStatusDropdown = async () => {
    const response = await fetch(
      `${webApi}/user_monitoring/monitoring_status_types_dropdown/`,
      options
    );
    const data = await response.json();
    setMonitoringStatus(data);
  };

  const fetchTodayLeadsData = async () => {
    setTodayLeadsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/dashboard/today_dashboard/`,
        options
      );
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.code === "token_not_valid") {
          navigate("/academic/sri-chaitanya/crm/landing-page");
        }
        throw new Error(errorData.detail || "Failed to fetch user data");
      }
      const data = await response.json();
      setTodayLeads(data);
    } catch (error) {
      console.error("Error fetching today's leads data:", error);
    } finally {
      setTodayLeadsLoading(false);
    }
  };

  const fetchDateRangeLeads = async (startDate: any, endDate: any) => {
    setTodayLeadsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/dashboard/conversation_dashboard/?from_date=${startDate}&to_date=${endDate}`,
        options
      );
      const data = await response.json();
      setDateRangeLeads(data);
    } catch (error) {
      console.error("Error fetching date range leads:", error);
    } finally {
      setTodayLeadsLoading(false);
    }
  };

  useEffect(() => {
    if (!checkPermission("can_view_summer_camp_dashboard", "Records")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData();
      fetchMonitoringStatusDropdown();
      fetchTodayLeadsData();
      fetchDateRangeLeads(startDate, endDate);
      fetchLeaderboard("today");
      fetchCalldDailyGraph();
      fetchSalesGraph();
      fetchSalesVsConnected();
      fetchSalesVsCallBacks();
      fetchSalesvsIntrested();
      fetchTop3();
      fetchOverall();
    }
  }, []);

  const data1 = [
    { name: "Mon", Calls: 80, Connected: 40 },
    { name: "Tue", Calls: 120, Connected: 90 },
    { name: "Wed", Calls: 100, Connected: 60 },
    { name: "Thu", Calls: 130, Connected: 85 },
    { name: "Fri", Calls: 90, Connected: 50 },
    { name: "Sat", Calls: 110, Connected: 80 },
  ];

  const [showCalendar, setShowCalendar] = useState(false);
  const [showCalendar1, setShowCalendar1] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(new Date().setHours(0, 0, 0, 0)),
      endDate: new Date(new Date().setHours(0, 0, 0, 0)),
      key: "selection",
    },
  ]);

  const startDate = format(dateRange[0].startDate, "yyyy-MM-dd");
  const endDate = format(dateRange[0].endDate, "yyyy-MM-dd");

  const handleFetchDateRangeLEads = () => {
    setShowCalendar1(false);
    fetchDateRangeLeads(startDate, endDate);
  };

  const [selectedAgents, setSelectedAgents] = useState<number[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<string>("");
  const handleCheckboxChange = (agentId: any) => {
    setSelectedAgents((prevSelected) => {
      if (prevSelected.includes(agentId)) {
        return prevSelected.filter((id) => id !== agentId);
      } else {
        return [...prevSelected, agentId];
      }
    });
  };

  const handleStatusChange = async (event: { target: { value: any } }) => {
    const statusId = event.target.value;
    setSelectedStatus(statusId);

    if (selectedAgents.length > 0 && statusId) {
      const payload = {
        user_ids: selectedAgents,
      };

      try {
        const response = await fetch(
          `${webApi}/user_monitoring/change_multiple_agents_status/${statusId}/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${jwtToken}`,
            },
            body: JSON.stringify(payload),
          }
        );

        if (response.ok) {
          // Handle success (e.g., show a success message)
          console.log("Status updated successfully");
          setIsStatusChange(true);
          // setTimeout(() => {
          //   setIsStatusChange(false);
          // }, 3000);
          setSelectedAgents([]);
          setSelectedStatus("");
          fetchData();
        } else {
          // Handle error (e.g., show an error message)
          console.error("Failed to update status");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const winRate = 7.802; // Example Win Rate (0-10%)
  const growth = 0.5; // Example Growth (+ or -)

  // Radial Bar Chart Data (Segments)
  const data2 = [
    { value: 2, fill: "#FDCFE2" }, // Light Pink
    { value: 3, fill: "#F48FB1" }, // Medium Pink
    { value: 5, fill: "#D32D7E" }, // Dark Pink
  ];

  // Convert winRate (0-10%) to an angle (180° to 0°)
  const needleAngle1 = (winRate / 10) * 180 - 180;

  const data3 = [
    { day: "Mon", sales: 95 },
    { day: "Tue", sales: 130 },
    { day: "Wed", sales: 85 },
    { day: "Thu", sales: 120 },
    { day: "Fri", sales: 75 },
    { day: "Sat", sales: 110 },
    { day: "Sun", sales: 140 },
  ];

  const sampleData = [{ value: 7.802 }];
  const sampleGrowth = 0.5;

  const data = [{ value: winRate }];
  const needleAngle = 180 - (winRate / 10) * 180;

  const containerStyle = {
    position: "fixed" as "fixed",
    bottom: "10px",
    right: "10px",
    display: "flex",
    flexDirection: "column" as "column",
    gap: "10px",
    backgroundColor: "rgba(255, 255, 255, 0.8)", // Optional: Add background for better visibility
    borderRadius: "8px", // Optional: Rounded corners
    padding: "10px", // Optional: Add some padding
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleCard = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper" style={{ background: "#E5DCDF" }}>
        <div className="content" style={{ background: "#E5DCDF" }}>
          <>
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
              <div className="my-auto mb-2">
                <h3 className="page-title mb-1">SummerCamp Dashboard</h3>
                <nav>
                  <ol className="breadcrumb mb-0">
                    {/* <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>Dashboard</Link>
                    </li> */}
                    <li className="breadcrumb-item active" aria-current="page">
                      SummerCamp Dashboard
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div
                style={{
                  color: "#484453",
                  marginBottom: "5px",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                Today’s Target Student
              </div>
              {todayLeadsLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin /> {/* Display loader while loading */}
                </div>
              ) : (
                <>
                  <div className="col-xxl-12 col-md-12 col-sm-12">
                    <div
                      className="grid-container"
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fill, minmax(260px, 1fr))",
                        gap: "10px",
                        justifyContent: "center",
                      }}
                    >
                      {/* {Array.from({ length: 6 }).map((_, index) => ( */}

                      <div
                        // key={index}
                        className="card flex-fill animate-card border-0 d-flex flex-column align-items-center justify-content-center"
                        style={{
                          height: "140px",
                          padding: "10px",
                          background: "#f8f9fa",
                          borderRadius: "8px",
                          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                          textAlign: "center",
                          position: "relative",
                          margin: "3px",
                        }}
                      >
                        {/* Heading */}
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "#6c757d",
                          }}
                        >
                          Calls/Students
                        </div>

                        {/* Score */}
                        <div
                          style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            marginTop: "5px",
                          }}
                        >
                          {todayLeads ? (
                            <>
                              {todayLeads.call_logs} / {todayLeads.total_leads}
                            </>
                          ) : (
                            "Loading..."
                          )}
                        </div>

                        {/* Growth Indicator */}
                        {/* <div
                      style={{
                        marginTop: "5px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "#28a745",
                      }}
                    >
                      ▲ 5%
                    </div> */}

                        {/* Progress Bar */}
                        <div
                          style={{
                            width: "80%",
                            height: "8px",
                            background: "#e9ecef",
                            borderRadius: "4px",
                            marginTop: "8px",
                            position: "relative",
                          }}
                        >
                          <div
                            style={{
                              width: `${todayLeads?.["call/leads_per"]}%`,
                              height: "100%",
                              background: "#D32D7E",
                              borderRadius: "4px",
                              transition: "width 1s ease",
                            }}
                          ></div>
                        </div>

                        {/* Percentage Label Below Progress Bar */}
                        <span
                          style={{
                            position: "absolute",
                            left: "12%", // Ensures it aligns properly at the start of the bar
                            bottom: "16px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            color: "#D32D7E",
                          }}
                        >
                          {`${todayLeads?.["call/leads_per"]}%`}
                        </span>
                      </div>
                      <div
                        // key={index}
                        className="card flex-fill animate-card border-0 d-flex flex-column align-items-center justify-content-center"
                        style={{
                          height: "140px",
                          padding: "10px",
                          background: "#f8f9fa",
                          borderRadius: "8px",
                          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                          textAlign: "center",
                          position: "relative",
                          margin: "3px",
                        }}
                      >
                        {/* Heading */}
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "#6c757d",
                          }}
                        >
                          Calls Connected
                        </div>

                        {/* Score */}
                        <div
                          style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            marginTop: "5px",
                          }}
                        >
                          {todayLeads ? (
                            <>
                              {todayLeads.connected_call_logs} /{" "}
                              {todayLeads.call_logs}
                            </>
                          ) : (
                            "Loading..."
                          )}
                        </div>

                        {/* Growth Indicator */}
                        {/* <div
                      style={{
                        marginTop: "5px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "#28a745",
                      }}
                    >
                      ▲ 5%
                    </div> */}

                        {/* Progress Bar */}
                        <div
                          style={{
                            width: "80%",
                            height: "8px",
                            background: "#e9ecef",
                            borderRadius: "4px",
                            marginTop: "8px",
                            position: "relative",
                            overflow: "hidden",
                          }}
                        >
                          <motion.div
                            initial={{ width: 0 }}
                            animate={{ width: `${todayLeads?.["calls_connected_per"]}%` }}
                            transition={{ duration: 1, ease: "easeInOut" }}
                            style={{
                              height: "100%",
                              background: "#D32D7E",
                              borderRadius: "4px",
                            }}
                          />
                        </div>

                        {/* Percentage Label Below Progress Bar */}
                        <motion.span
                          initial={{ opacity: 0, x: -10 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ duration: 1, ease: "easeInOut" }}
                          style={{
                            position: "absolute",
                            left: "12%",
                            bottom: "16px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            color: "#D32D7E",
                          }}
                        >
                          {`${todayLeads?.["calls_connected_per"]}%`}
                        </motion.span>
                      </div>
                      <div
                        // key={index}
                        className="card flex-fill animate-card border-0 d-flex flex-column align-items-center justify-content-center"
                        style={{
                          height: "140px",
                          padding: "10px",
                          background: "#f8f9fa",
                          borderRadius: "8px",
                          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                          textAlign: "center",
                          position: "relative",
                          margin: "3px",
                        }}
                      >
                        {/* Heading */}
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "#6c757d",
                          }}
                        >
                          Intrested
                        </div>

                        {/* Score */}
                        <div
                          style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            marginTop: "5px",
                          }}
                        >
                          {todayLeads ? (
                            <>
                              {todayLeads.interested} /{" "}
                              {todayLeads.connected_call_logs}
                            </>
                          ) : (
                            "Loading..."
                          )}
                        </div>

                        {/* Growth Indicator */}
                        {/* <div
                      style={{
                        marginTop: "5px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "#28a745",
                      }}
                    >
                      ▲ 5%
                    </div> */}

                        {/* Progress Bar */}
                        <div
                          style={{
                            width: "80%",
                            height: "8px",
                            background: "#e9ecef",
                            borderRadius: "4px",
                            marginTop: "8px",
                            position: "relative",
                            overflow: "hidden",
                          }}
                        >
                          <motion.div
                            initial={{ width: 0 }}
                            animate={{ width: `${todayLeads?.["interested_per"]}%` }}
                            transition={{ duration: 1, ease: "easeInOut" }}
                            style={{
                              height: "100%",
                              background: "#D32D7E",
                              borderRadius: "4px",
                            }}
                          />

                        </div>

                        {/* Percentage Label Below Progress Bar */}
                        <motion.span
                          initial={{ opacity: 0, x: -10 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ duration: 1, ease: "easeInOut" }}
                          style={{
                            position: "absolute",
                            left: "12%",
                            bottom: "16px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            color: "#D32D7E",
                          }}
                        >
                          {`${todayLeads?.["interested_per"]}%`}
                        </motion.span>

                      </div>
                      <div
                        // key={index}
                        className="card flex-fill animate-card border-0 d-flex flex-column align-items-center justify-content-center"
                        style={{
                          height: "140px",
                          padding: "10px",
                          background: "#f8f9fa",
                          borderRadius: "8px",
                          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                          textAlign: "center",
                          position: "relative",
                          margin: "3px",
                        }}
                      >
                        {/* Heading */}
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "#6c757d",
                          }}
                        >
                          Call Backs
                        </div>

                        {/* Score */}
                        <div
                          style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            marginTop: "5px",
                          }}
                        >
                          {todayLeads ? (
                            <>
                              {todayLeads.call_backs} /{" "}
                              {todayLeads.connected_call_logs}
                            </>
                          ) : (
                            "Loading..."
                          )}
                        </div>

                        {/* Growth Indicator */}
                        {/* <div
                      style={{
                        marginTop: "5px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "#28a745",
                      }}
                    >
                      ▲ 5%
                    </div> */}

                        {/* Progress Bar */}
                        <div
                          style={{
                            width: "80%",
                            height: "8px",
                            background: "#e9ecef",
                            borderRadius: "4px",
                            marginTop: "8px",
                            position: "relative",
                            overflow: "hidden",
                          }}
                        >
                          <motion.div
                            initial={{ width: 0 }}
                            animate={{ width: `${todayLeads?.["call_backs_per"]}%` }}
                            transition={{ duration: 1, ease: "easeInOut" }}
                            style={{
                              height: "100%",
                              background: "#D32D7E",
                              borderRadius: "4px",
                            }}
                          />
                          {/* <div
                                                            style={{
                                                                width: `${todayLeads?.["call_backs_per"]}%`,
                                                                height: "100%",
                                                                background: "#D32D7E",
                                                                borderRadius: "4px",
                                                            }}
                                                        ></div> */}
                        </div>

                        {/* Percentage Label Below Progress Bar */}
                        <motion.span
                          initial={{ opacity: 0, x: -10 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ duration: 1, ease: "easeInOut" }}
                          style={{
                            position: "absolute",
                            left: "12%",
                            bottom: "16px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            color: "#D32D7E",
                          }}
                        >
                          {`${todayLeads?.["call_backs_per"]}%`}
                        </motion.span>

                      </div>
                      <div
                        // key={index}
                        className="card flex-fill animate-card border-0 d-flex flex-column align-items-center justify-content-center"
                        style={{
                          height: "140px",
                          padding: "10px",
                          background: "#f8f9fa",
                          borderRadius: "8px",
                          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                          textAlign: "center",
                          position: "relative",
                          margin: "3px",
                        }}
                      >
                        {/* Heading */}
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "#6c757d",
                          }}
                        >
                          Sold/Connected
                        </div>

                        {/* Score */}
                        <div
                          style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            marginTop: "5px",
                          }}
                        >
                          {todayLeads ? (
                            <>
                              {todayLeads.sales} /{" "}
                              {todayLeads.connected_call_logs}
                            </>
                          ) : (
                            "Loading..."
                          )}
                        </div>

                        {/* Growth Indicator */}
                        {/* <div
                      style={{
                        marginTop: "5px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "#28a745",
                      }}
                    >
                      ▲ 5%
                    </div> */}

                        {/* Progress Bar */}
                        <div
                          style={{
                            width: "80%",
                            height: "8px",
                            background: "#e9ecef",
                            borderRadius: "4px",
                            marginTop: "8px",
                            position: "relative",
                            overflow: "hidden",
                          }}
                        >
                          <motion.div
                            initial={{ width: 0 }}
                            animate={{ width: `${todayLeads?.["sales_per"]}%` }}
                            transition={{ duration: 1, ease: "easeInOut" }}
                            style={{
                              height: "100%",
                              background: "#D32D7E",
                              borderRadius: "4px",
                            }}
                          />

                        </div>

                        {/* Percentage Label Below Progress Bar */}
                        <motion.span
                          initial={{ opacity: 0, x: -10 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ duration: 1, ease: "easeInOut" }}
                          style={{
                            position: "absolute",
                            left: "12%",
                            bottom: "16px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            color: "#D32D7E",
                          }}
                        >
                          {`${todayLeads?.["sales_per"]}%`}
                        </motion.span>
                        {/* <span
                                                    style={{
                                                        position: "absolute",
                                                        left: "12%", // Ensures it aligns properly at the start of the bar
                                                        bottom: "16px",
                                                        fontSize: "12px",
                                                        fontWeight: "bold",
                                                        color: "#D32D7E",
                                                    }}
                                                >
                                                    {`${todayLeads?.["sales_per"]}%`}
                                                </span> */}
                      </div>

                      <div
                        // key={index}
                        className="card flex-fill animate-card border-0 d-flex flex-column align-items-center justify-content-center"
                        style={{
                          height: "140px",
                          padding: "10px",
                          background: "#f8f9fa",
                          borderRadius: "8px",
                          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                          textAlign: "center",
                          position: "relative",
                          margin: "3px",
                        }}
                      >
                        {/* Heading */}
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "#6c757d",
                          }}
                        >
                          Avg. Duration
                        </div>

                        {/* Score */}
                        <div
                          style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            marginTop: "5px",
                          }}
                        >
                          {todayLeads ? (
                            <>{todayLeads.average_conversation_duration}</>
                          ) : (
                            "Loading..."
                          )}
                        </div>

                        {/* Growth Indicator */}
                        {/* <div
                      style={{
                        marginTop: "5px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "#28a745",
                      }}
                    >
                      ▲ 5%
                    </div> */}

                        {/* Progress Bar */}
                        {/* <div
                      style={{
                        width: "80%",
                        height: "8px",
                        background: "#e9ecef",
                        borderRadius: "4px",
                        marginTop: "8px",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          width: "80%",
                          height: "100%",
                          background: "#D32D7E",
                          borderRadius: "4px",
                        }}
                      ></div>
                    </div> */}

                        {/* Percentage Label Below Progress Bar */}
                        {/* <span
                      style={{
                        position: "absolute",
                        left: "12%", // Ensures it aligns properly at the start of the bar
                        bottom: "5px",
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "#D32D7E",
                      }}
                    >
                      80%
                    </span> */}
                      </div>
                      {checkPermission("view_summer_camp_sales_revenue", "custom_model") && (
                        <div
                          // key={index}
                          className="card flex-fill animate-card border-0 d-flex flex-column align-items-center justify-content-center"
                          style={{
                            height: "140px",
                            padding: "10px",
                            background: "#f8f9fa",
                            borderRadius: "8px",
                            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                            textAlign: "center",
                            position: "relative",
                            margin: "3px",
                          }}
                        >
                          {/* Heading */}
                          <div
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: "#6c757d",
                            }}
                          >
                            Archived/Target
                          </div>

                          {/* Score */}
                          <div
                            style={{
                              fontSize: "18px",
                              fontWeight: "bold",
                              marginTop: "5px",
                            }}
                          >
                            {todayLeads ? (
                              <>
                                {todayLeads.achieved_amount} /{" "}
                                {todayLeads.target_amount}
                              </>
                            ) : (
                              "Loading..."
                            )}
                          </div>

                          {/* Growth Indicator */}
                          {/* <div
                                            style={{
                                              marginTop: "5px",
                                              fontSize: "14px",
                                              fontWeight: "bold",
                                              color: "#28a745",
                                            }}
                                          >
                                            ▲ 5%
                                          </div> */}

                          {/* Progress Bar */}
                          <div
                            style={{
                              width: "80%",
                              height: "8px",
                              background: "#e9ecef",
                              borderRadius: "4px",
                              marginTop: "8px",
                              position: "relative",
                              overflow: "hidden",
                            }}
                          >
                            <motion.div
                              initial={{ width: 0 }}
                              animate={{ width: `${todayLeads?.["target_amount_per"]}%` }}
                              transition={{ duration: 1, ease: "easeInOut" }}
                              style={{
                                height: "100%",
                                background: "#D32D7E",
                                borderRadius: "4px",
                              }}
                            />

                          </div>

                          {/* Percentage Label Below Progress Bar */}
                          <motion.span
                            initial={{ opacity: 0, x: -10 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 1, ease: "easeInOut" }}
                            style={{
                              position: "absolute",
                              left: "12%",
                              bottom: "16px",
                              fontSize: "12px",
                              fontWeight: "bold",
                              color: "#D32D7E",
                            }}
                          >
                            {`${todayLeads?.["target_amount_per"]}%`}
                          </motion.span>
                          {/* <span
                                                                          style={{
                                                                              position: "absolute",
                                                                              left: "12%", // Ensures it aligns properly at the start of the bar
                                                                              bottom: "16px",
                                                                              fontSize: "12px",
                                                                              fontWeight: "bold",
                                                                              color: "#D32D7E",
                                                                          }}
                                                                      >
                                                                          {`${todayLeads?.["sales_per"]}%`}
                                                                      </span> */}
                        </div>
                      )}

                      {/* ))} */}
                    </div>
                  </div>
                </>
              )}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {/* Heading */}
                <h4
                  style={{
                    color: "#484453",
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  Conversations
                </h4>

                {/* Date Picker Button */}
                <div style={{ position: "relative" }}>
                  <div
                    onClick={() => setShowCalendar1(!showCalendar1)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "8px 15px",
                      background: "white",
                      borderRadius: "20px",
                      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "#34303D",
                      cursor: "pointer",
                      border: "1px solid #ddd",
                      minWidth: "200px",
                      justifyContent: "center",
                      marginTop: "5px",
                    }}
                  >
                    {format(dateRange[0].startDate, "dd MMM yy")} –{" "}
                    {format(dateRange[0].endDate, "dd MMM yy")}
                    <span style={{ marginLeft: "10px" }}>▼</span>
                    <FontAwesomeIcon
                      icon={faSearch as any}
                      style={{ marginLeft: "10px" }}
                      onClick={handleFetchDateRangeLEads}
                    />
                  </div>

                  {/* Calendar Popup (Positioned Below) */}
                  {showCalendar1 && (
                    <div
                      style={{
                        position: "absolute",
                        zIndex: 2000,
                        background: "white",
                        borderRadius: "10px",
                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                        padding: "5px",
                        left: "-130px" /* Move the element to the left */,
                      }}
                    >
                      <DateRange
                        ranges={dateRange}
                        onChange={(item) =>
                          setDateRange([
                            {
                              startDate: item.selection.startDate || new Date(),
                              endDate: item.selection.endDate || new Date(),
                              key: "selection",
                            },
                          ])
                        }
                        moveRangeOnFirstSelection={false}
                        rangeColors={["blue"]} // Dark color from your UI
                      />
                    </div>
                  )}
                </div>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", // Split into 50% - 50%
                  gap: "20px",
                  padding: "20px",
                }}
              >
                {/* LEFT HALF - CARDS */}
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {/* Grid layout for cards */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fill, minmax(170px, 1fr))",
                      gap: "15px",
                    }}
                  >
                    {/* {Array.from({ length: 6 }).map((_, index) => ( */}
                    <div
                      // key={index}
                      className="card"
                      style={{
                        height: "140px",
                        padding: "15px",
                        background: "#f8f9fa",
                        borderRadius: "12px",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        textAlign: "center",
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "transform 0.2s ease-in-out",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "scale(1.05)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                    >
                      {/* Heading */}
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#6c757d",
                        }}
                      >
                        Calls/Students
                      </div>

                      {/* Score */}
                      <div
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          marginTop: "5px",
                        }}
                      >
                        {dateRangeLeads ? (
                          <>
                            {dateRangeLeads.call_logs} /{" "}
                            {dateRangeLeads.total_leads}
                          </>
                        ) : (
                          "Loading..."
                        )}
                      </div>

                      {/* Growth Indicator */}
                      {/* <div
                        style={{
                          marginTop: "5px",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#28a745",
                        }}
                      >
                        ▲ 5%
                      </div> */}

                      {/* Progress Bar */}
                      <div
                        style={{
                          width: "80%",
                          height: "8px",
                          background: "#e9ecef",
                          borderRadius: "4px",
                          marginTop: "8px",
                          position: "relative",
                          overflow: "hidden",
                        }}
                      >
                        <motion.div
                          initial={{ width: 0 }}
                          animate={{ width: `${dateRangeLeads?.["call/leads_per"]}%` }}
                          transition={{ duration: 1, ease: "easeInOut" }}
                          style={{
                            height: "100%",
                            background: "#D32D7E",
                            borderRadius: "4px",
                          }}
                        />

                      </div>

                      {/* Percentage Label Below Progress Bar */}
                      <motion.span
                        initial={{ opacity: 0, x: -10 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        style={{
                          position: "absolute",
                          left: "12%",
                          bottom: "16px",
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "#D32D7E",
                        }}
                      >
                        {`${dateRangeLeads?.["call/leads_per"]}%`}
                      </motion.span>
                    </div>
                    <div
                      // key={index}
                      className="card"
                      style={{
                        height: "140px",
                        padding: "15px",
                        background: "#f8f9fa",
                        borderRadius: "12px",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        textAlign: "center",
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "transform 0.2s ease-in-out",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "scale(1.05)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                    >
                      {/* Heading */}
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#6c757d",
                        }}
                      >
                        Calls Connected
                      </div>

                      {/* Score */}
                      <div
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          marginTop: "5px",
                        }}
                      >
                        {dateRangeLeads ? (
                          <>
                            {dateRangeLeads.connected_call_logs} /{" "}
                            {dateRangeLeads.call_logs}
                          </>
                        ) : (
                          "Loading..."
                        )}
                      </div>

                      {/* Growth Indicator */}
                      {/* <div
                        style={{
                          marginTop: "5px",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#28a745",
                        }}
                      >
                        ▲ 5%
                      </div> */}

                      {/* Progress Bar */}
                      <div
                        style={{
                          width: "80%",
                          height: "8px",
                          background: "#e9ecef",
                          borderRadius: "4px",
                          marginTop: "8px",
                          position: "relative",
                          overflow: "hidden",
                        }}
                      >
                        <motion.div
                          initial={{ width: 0 }}
                          animate={{ width: `${dateRangeLeads?.["calls_connected_per"]}%` }}
                          transition={{ duration: 1, ease: "easeInOut" }}
                          style={{
                            height: "100%",
                            background: "#D32D7E",
                            borderRadius: "4px",
                          }}
                        />

                      </div>

                      {/* Percentage Label Below Progress Bar */}
                      <motion.span
                        initial={{ opacity: 0, x: -10 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        style={{
                          position: "absolute",
                          left: "12%",
                          bottom: "16px",
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "#D32D7E",
                        }}
                      >
                        {`${dateRangeLeads?.["calls_connected_per"]}%`}
                      </motion.span>
                      {/* <span
                                                style={{
                                                    position: "absolute",
                                                    left: "15%",
                                                    bottom: "16px",
                                                    fontSize: "12px",
                                                    fontWeight: "bold",
                                                    color: "#D32D7E",
                                                }}
                                            >
                                                {`${dateRangeLeads?.["calls_connected_per"]}%`}
                                            </span> */}
                    </div>
                    <div
                      // key={index}
                      className="card"
                      style={{
                        height: "140px",
                        padding: "15px",
                        background: "#f8f9fa",
                        borderRadius: "12px",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        textAlign: "center",
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "transform 0.2s ease-in-out",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "scale(1.05)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                    >
                      {/* Heading */}
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#6c757d",
                        }}
                      >
                        Intrested
                      </div>

                      {/* Score */}
                      <div
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          marginTop: "5px",
                        }}
                      >
                        {dateRangeLeads ? (
                          <>
                            {dateRangeLeads.interested} /{" "}
                            {dateRangeLeads.connected_call_logs}
                          </>
                        ) : (
                          "Loading..."
                        )}
                      </div>

                      {/* Growth Indicator */}
                      {/* <div
                        style={{
                          marginTop: "5px",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#28a745",
                        }}
                      >
                        ▲ 5%
                      </div> */}

                      {/* Progress Bar */}
                      <div
                        style={{
                          width: "80%",
                          height: "8px",
                          background: "#e9ecef",
                          borderRadius: "4px",
                          marginTop: "8px",
                          position: "relative",
                          overflow: "hidden",
                        }}
                      >
                        <motion.div
                          initial={{ width: 0 }}
                          animate={{ width: `${dateRangeLeads?.["interested_per"]}%` }}
                          transition={{ duration: 1, ease: "easeInOut" }}
                          style={{
                            height: "100%",
                            background: "#D32D7E",
                            borderRadius: "4px",
                          }}
                        />
                        {/* <div
                                                    style={{
                                                        width: `${dateRangeLeads?.["interested_per"]}%`,
                                                        height: "100%",
                                                        background: "#D32D7E",
                                                        borderRadius: "4px",
                                                    }}
                                                ></div> */}
                      </div>

                      {/* Percentage Label Below Progress Bar */}
                      <motion.span
                        initial={{ opacity: 0, x: -10 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        style={{
                          position: "absolute",
                          left: "12%",
                          bottom: "16px",
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "#D32D7E",
                        }}
                      >
                        {`${dateRangeLeads?.["interested_per"]}%`}
                      </motion.span>
                    </div>
                    <div
                      // key={index}
                      className="card"
                      style={{
                        height: "140px",
                        padding: "15px",
                        background: "#f8f9fa",
                        borderRadius: "12px",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        textAlign: "center",
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "transform 0.2s ease-in-out",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "scale(1.05)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                    >
                      {/* Heading */}
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#6c757d",
                        }}
                      >
                        Call Backs
                      </div>

                      {/* Score */}
                      <div
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          marginTop: "5px",
                        }}
                      >
                        {dateRangeLeads ? (
                          <>
                            {dateRangeLeads.call_backs} /{" "}
                            {dateRangeLeads.connected_call_logs}
                          </>
                        ) : (
                          "Loading..."
                        )}
                      </div>

                      {/* Growth Indicator */}
                      {/* <div
                        style={{
                          marginTop: "5px",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#28a745",
                        }}
                      >
                        ▲ 5%
                      </div> */}

                      {/* Progress Bar */}
                      <div
                        style={{
                          width: "80%",
                          height: "8px",
                          background: "#e9ecef",
                          borderRadius: "4px",
                          marginTop: "8px",
                          position: "relative",
                          overflow: "hidden",
                        }}
                      >
                        <motion.div
                          initial={{ width: 0 }}
                          animate={{ width: `${dateRangeLeads?.["call_backs_per"]}%` }}
                          transition={{ duration: 1, ease: "easeInOut" }}
                          style={{
                            height: "100%",
                            background: "#D32D7E",
                            borderRadius: "4px",
                          }}
                        />
                      </div>

                      {/* Percentage Label Below Progress Bar */}
                      <motion.span
                        initial={{ opacity: 0, x: -10 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        style={{
                          position: "absolute",
                          left: "12%",
                          bottom: "16px",
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "#D32D7E",
                        }}
                      >
                        {`${dateRangeLeads?.["call_backs_per"]}%`}
                      </motion.span>
                    </div>
                    <div
                      // key={index}
                      className="card"
                      style={{
                        height: "140px",
                        padding: "15px",
                        background: "#f8f9fa",
                        borderRadius: "12px",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        textAlign: "center",
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "transform 0.2s ease-in-out",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "scale(1.05)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                    >
                      {/* Heading */}
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#6c757d",
                        }}
                      >
                        Not Intrested
                      </div>

                      {/* Score */}
                      <div
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          marginTop: "5px",
                        }}
                      >
                        {dateRangeLeads ? (
                          <>
                            {dateRangeLeads.not_interested} /{" "}
                            {dateRangeLeads.connected_call_logs}
                          </>
                        ) : (
                          "Loading..."
                        )}
                      </div>

                      {/* Growth Indicator */}
                      {/* <div
                        style={{
                          marginTop: "5px",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#28a745",
                        }}
                      >
                        ▲ 5%
                      </div> */}

                      {/* Progress Bar */}
                      <div
                        style={{
                          width: "80%",
                          height: "8px",
                          background: "#e9ecef",
                          borderRadius: "4px",
                          marginTop: "8px",
                          position: "relative",
                          overflow: "hidden",
                        }}
                      >
                        <motion.div
                          initial={{ width: 0 }}
                          animate={{ width: `${dateRangeLeads?.["not_interested_per"]}%` }}
                          transition={{ duration: 1, ease: "easeInOut" }}
                          style={{
                            height: "100%",
                            background: "#D32D7E",
                            borderRadius: "4px",
                          }}
                        />
                        {/* <div
                                                    style={{
                                                        width: `${dateRangeLeads?.["not_interested_per"]}%`,
                                                        height: "100%",
                                                        background: "#D32D7E",
                                                        borderRadius: "4px",
                                                    }}
                                                ></div> */}
                      </div>

                      {/* Percentage Label Below Progress Bar */}
                      <motion.span
                        initial={{ opacity: 0, x: -10 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        style={{
                          position: "absolute",
                          left: "12%",
                          bottom: "16px",
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "#D32D7E",
                        }}
                      >
                        {`${dateRangeLeads?.["not_interested_per"]}%`}
                      </motion.span>
                    </div>
                    <div
                      // key={index}
                      className="card"
                      style={{
                        height: "140px",
                        padding: "15px",
                        background: "#f8f9fa",
                        borderRadius: "12px",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        textAlign: "center",
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "transform 0.2s ease-in-out",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "scale(1.05)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                    >
                      {/* Heading */}
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#6c757d",
                        }}
                      >
                        Avg. Duration
                      </div>

                      {/* Score */}
                      <div
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          marginTop: "5px",
                        }}
                      >
                        {dateRangeLeads ? (
                          <>{dateRangeLeads.average_conversation_duration}</>
                        ) : (
                          "Loading..."
                        )}
                      </div>

                      {/* Growth Indicator */}
                      {/* <div
                        style={{
                          marginTop: "5px",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#28a745",
                        }}
                      >
                        ▲ 5%
                      </div> */}

                      {/* Progress Bar */}
                      {/* <div
                        style={{
                          width: "80%",
                          height: "8px",
                          background: "#e9ecef",
                          borderRadius: "4px",
                          marginTop: "8px",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            width: "80%",
                            height: "100%",
                            background: "#D32D7E",
                            borderRadius: "4px",
                          }}
                        ></div>
                      </div> */}

                      {/* Percentage Label Below Progress Bar */}
                      {/* <span
                        style={{
                          position: "absolute",
                          left: "15%",
                          bottom: "5px",
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "#D32D7E",
                        }}
                      >
                        80%
                      </span> */}
                    </div>
                    {/* ))} */}
                  </div>
                </div>

                {/* RIGHT HALF - BAR CHART */}
                <div
                  style={{
                    background: "white",
                    borderRadius: "12px",
                    padding: "10px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    maxHeight: "319px",
                    width: "100%", // Ensure it takes full width within the grid
                  }}
                >
                  <h4
                    style={{
                      marginBottom: "10px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "#6c757d",
                    }}
                  >
                    Calls Daily
                  </h4>

                  <ResponsiveContainer width="100%" height={250}>
                    <BarChart data={CallsDailyGraph} barSize={10}>
                      <XAxis
                        dataKey="label"
                        tick={{
                          fill: "#6c757d",
                          fontSize: 14,
                          fontWeight: "bold",
                        }}
                      />
                      <YAxis tick={{ fill: "#6c757d", fontSize: 12 }} />
                      <Tooltip />
                      <Legend
                        iconType="circle"
                        wrapperStyle={{
                          fontSize: 14,
                          fontWeight: "bold",
                          color: "#6c757d",
                        }}
                      />
                      <Bar
                        dataKey="connected"
                        fill="#4CAF50"
                        radius={[5, 5, 0, 0]}
                      />
                      <Bar
                        dataKey="calls"
                        fill="#34303D"
                        radius={[5, 5, 0, 0]}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
              <div
                style={{
                  // gridColumn: "span 9",
                  padding: "16px",
                  borderRadius: "8px",
                  width: "100%",
                  color: "black",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#A43971",
                    padding: "16px",
                    borderRadius: "8px 8px 0 0",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <h2
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      color: "white",
                      margin: "0 16px 0 0",
                    }}
                  >
                    Agent Activity
                  </h2>
                  <select
                    onChange={handleStatusChange}
                    value={selectedStatus}
                    disabled={selectedAgents.length === 0}
                  >
                    <option value="" selected>
                      Select
                    </option>
                    {monitoringStatus &&
                      monitoringStatus.map((status) => (
                        <option key={status.id} value={status.id}>
                          {status.name}
                        </option>
                      ))}
                  </select>

                  <BiRefresh
                    style={{
                      marginLeft: "8px",
                      cursor: "pointer",
                      height: "19px",
                      width: "35px",
                      animation: refreshIsLoading ? "spin 1s linear infinite" : "none",
                    }}
                    onClick={fetchData}
                  />
                  <style>
                    {`
                                        @keyframes spin {
                                            0% {
                                            transform: rotate(0deg);
                                            }
                                            100% {
                                            transform: rotate(360deg);
                                            }
                                        }
                                        `}
                  </style>
                </div>

                <div
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    borderRadius: "0 0 8px 8px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      maxHeight: "400px", // Set a max height for vertical scrolling
                      overflowY: "auto", // Enable vertical scrolling
                      overflowX: "auto", // Enable horizontal scrolling
                    }}
                  >
                    <table style={{ width: "100%", fontSize: "14px" }}>
                      <thead
                        style={{ backgroundColor: "#F3F4F6", color: "#374151" }}
                      >
                        <tr>
                          <th style={{ padding: "8px", textAlign: "left" }}>
                            Action
                          </th>
                          <th style={{ padding: "8px", textAlign: "left" }}>
                            Agent Name
                          </th>
                          <th style={{ padding: "8px", textAlign: "left" }}>
                            Status
                          </th>
                          <th style={{ padding: "8px", textAlign: "center" }}>
                            Session Duration
                          </th>
                          <th style={{ padding: "8px", textAlign: "center" }}>
                            Calls
                          </th>
                          <th style={{ padding: "8px", textAlign: "center" }}>
                            Connected
                          </th>
                          <th style={{ padding: "8px", textAlign: "center" }}>
                            Interested
                          </th>
                          <th style={{ padding: "8px", textAlign: "center" }}>
                            Call backs
                          </th>
                          <th style={{ padding: "8px", textAlign: "center" }}>
                            Sale
                          </th>
                          <th style={{ padding: "8px", textAlign: "center" }}>
                            Ideal Time
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {dashboardData &&
                          dashboardData.map((agent, index) => (
                            <tr
                              key={index}
                              style={{ borderTop: "1px solid #E5E7EB" }}
                            >
                              <td style={{ padding: "8px" }}>
                                <input
                                  type="checkbox"
                                  checked={selectedAgents.includes(agent.id)}
                                  onChange={() =>
                                    handleCheckboxChange(agent.id)
                                  }
                                  disabled={
                                    agent.status_name === "Offline" ||
                                    agent.status_name === "On Call"
                                  }
                                />
                              </td>

                              <td style={{ padding: "8px" }}>
                                {agent.agent_name}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {agent.status_name}
                              </td>
                              <td
                                style={{ padding: "8px", textAlign: "center" }}
                              >
                                <Counter updatedAt={agent.updated_at} />
                              </td>
                              <td style={{ padding: "8px", textAlign: "center" }}>
                                {agent.calls}{" "}
                                {/* <span style={{ color: Number(agent.calls) > 0 ? "green" : "red" }}>
                                                                    {Number(agent.calls) > 0 ? "▲" : "▼"}
                                                                </span> */}
                              </td>
                              <td style={{ padding: "8px", textAlign: "center" }}>
                                {agent.connected}{" "}
                                {/* <span style={{ color: Number(agent.connected) > 0 ? "green" : "red" }}>
                                                                    {Number(agent.connected) > 0 ? "▲" : "▼"}
                                                                </span> */}
                              </td>
                              <td style={{ padding: "8px", textAlign: "center" }}>
                                {agent.interested}{" "}
                                {/* <span style={{ color: Number(agent.interested) > 0 ? "green" : "red" }}>
                                                                    {Number(agent.interested) > 0 ? "▲" : "▼"}
                                                                </span> */}
                              </td>
                              <td style={{ padding: "8px", textAlign: "center" }}>
                                {agent.callbacks}{" "}
                                {/* <span style={{ color: Number(agent.callbacks) > 0 ? "green" : "red" }}>
                                                                    {Number(agent.callbacks) > 0 ? "▲" : "▼"}
                                                                </span> */}
                              </td>
                              <td style={{ padding: "8px", textAlign: "center" }}>
                                {agent.sale}{" "}
                                {/* <span style={{ color: Number(agent.sale) > 0 ? "green" : "red" }}>
                                                                    {Number(agent.sale) > 0 ? "▲" : "▼"}
                                                                </span> */}
                              </td>

                              <td
                                style={{ padding: "8px", textAlign: "center" }}
                              >
                                {agent.total_ideal_time}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {/* Heading */}
                <h4
                  style={{
                    color: "#484453",
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  Sales Summary
                </h4>

                {/* Date Picker Button */}
                <div style={{ position: "relative" }}>
                  {/* <div
                                        onClick={() => setShowCalendar(!showCalendar)}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "8px 15px",
                                            background: "white",
                                            borderRadius: "20px",
                                            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                                            fontSize: "12px",
                                            fontWeight: "bold",
                                            color: "#34303D",
                                            cursor: "pointer",
                                            border: "1px solid #ddd",
                                            minWidth: "200px",
                                            justifyContent: "center",
                                            marginTop: "5px",
                                        }}
                                    >
                                        {format(dateRange[0].startDate, "dd MMM yy")} –{" "}
                                        {format(dateRange[0].endDate, "dd MMM yy")}
                                        <span style={{ marginLeft: "10px" }}>▼</span>
                                    </div> */}

                  {/* Calendar Popup (Positioned Below) */}
                  {/* {showCalendar && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                // top: "calc(100% + 5px)",

                                                zIndex: 2000,
                                                background: "white",
                                                borderRadius: "10px",
                                                boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                                padding: "5px",
                                                left: "-130px",
                                            }}
                                        >
                                            <DateRange
                                                ranges={dateRange}
                                                onChange={(item) =>
                                                    setDateRange([
                                                        {
                                                            startDate: item.selection.startDate || new Date(),
                                                            endDate: item.selection.endDate || new Date(),
                                                            key: "selection",
                                                        },
                                                    ])
                                                }
                                                moveRangeOnFirstSelection={false}
                                                rangeColors={["blue"]} // Dark color from your UI
                                            />
                                        </div>
                                    )} */}
                </div>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
                  gap: "20px",
                  padding: "20px",
                }}
              >
                {/* <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(350px, 1fr))",
                    gap: "15px",
                  }}
                > */}
                <div
                  style={{
                    background: "white",
                    borderRadius: "12px",
                    padding: "20px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    textAlign: "center",
                    width: "100%",
                    height: "300px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      background: "#4A4A5C",
                      color: "white",
                      padding: "8px",
                      fontSize: "24px",
                      fontWeight: "bold",
                      position: "absolute",
                      top: "0",
                      left: "0",
                      right: "0",
                      borderTopLeftRadius: "12px",
                      borderTopRightRadius: "12px",
                    }}
                  >
                    Today Top 3
                  </div>

                  <div
                    style={{
                      marginTop: "60px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "12px",
                    }}
                  >
                    {top3Wizklub.map((agent, index) => (
                      <div
                        key={agent.agent_id}
                        style={{
                          flex: "1",
                          // background: "#f7f7f7",
                          padding: "12px",
                          borderRadius: "8px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        {/* <span style={{ fontWeight: "bold", fontSize: "18px" }}>{index + 1}.</span> */}
                        <img
                          src={
                            agent.agent_profile && agent.agent_profile.trim() !== ''
                              ? `${webApi}${agent.agent_profile}`
                              : 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png'
                          }
                          alt={agent.agent_name}
                          style={{
                            width: "70px",
                            height: "70px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            marginTop: "8px",
                            marginBottom: "8px",
                          }}
                        />
                        <div style={{ fontWeight: "bold", textAlign: "center" }}>
                          {agent.agent_name.match(/.{1,9}/g).map((chunk: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined, idx: React.Key | null | undefined) => (
                            <span key={idx}>
                              {chunk}
                              <br />
                            </span>
                          ))}
                        </div>

                        <div style={{ fontSize: "12px", color: "#555" }}>
                          Sales: {agent.sales_count}
                        </div>
                      </div>
                    ))}
                  </div>

                </div>
                <div
                  style={{
                    background: "white",
                    borderRadius: "12px",
                    padding: "20px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    textAlign: "center",
                    width: "100%",
                    minWidth: "350px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      background: "#4A4A5C",
                      color: "white",
                      padding: "8px",
                      fontSize: "24px",
                      fontWeight: "bold",
                      position: "absolute",
                      top: "0",
                      left: "0",
                      right: "0",
                      borderTopLeftRadius: "12px",
                      borderTopRightRadius: "12px",
                    }}
                  >
                    All Time Top 3
                  </div>
                  <div
                    style={{
                      marginTop: "60px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "12px",
                    }}
                  >
                    {overall.map((agent, index) => (
                      <div
                        key={agent.agent_id}
                        style={{
                          flex: "1",
                          // background: "#f7f7f7",
                          padding: "12px",
                          borderRadius: "8px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        {/* <span style={{ fontWeight: "bold", fontSize: "18px" }}>{index + 1}.</span> */}
                        <img
                          src={
                            agent.agent_profile && agent.agent_profile.trim() !== ''
                              ? `${webApi}${agent.agent_profile}`
                              : 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png'
                          }
                          alt={agent.agent_name}
                          style={{
                            width: "70px",
                            height: "70px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            marginTop: "8px",
                            marginBottom: "8px",
                          }}
                        />
                        <div style={{ fontWeight: "bold", textAlign: "center" }}>
                          {agent.agent_name.match(/.{1,9}/g).map((chunk: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined, idx: React.Key | null | undefined) => (
                            <span key={idx}>
                              {chunk}
                              <br />
                            </span>
                          ))}
                        </div>

                        <div style={{ fontSize: "12px", color: "#555" }}>
                          Sales: {agent.sales_count}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {/* </div> */}
                <div
                  style={{
                    background: "white",
                    borderRadius: "12px",
                    padding: "10px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    maxHeight: "335px",
                    width: "100%",
                  }}
                >
                  <h3
                    style={{
                      marginBottom: "10px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "#6c757d",
                    }}
                  >
                    Sales Daily
                  </h3>
                  <ResponsiveContainer width="100%" height={250}>
                    <BarChart data={salesDaily} barSize={20}>
                      <CartesianGrid strokeDasharray="3 3" vertical={false} />
                      <XAxis
                        dataKey="label"
                        tick={{ fill: "#6B7280", fontSize: 14 }}
                      />
                      <YAxis
                        tick={{ fill: "#6B7280", fontSize: 14 }}
                        domain={[0, 150]}
                      />
                      <Tooltip />
                      <Bar
                        dataKey="sales"
                        fill="#3F3D56"
                        radius={[5, 5, 0, 0]}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
                  gap: "20px",
                  width: "100%",
                }}
              >
                {/* {[...Array(3)].map((_, index) => ( */}
                <div
                  // key={index}
                  style={{
                    background: "white",
                    borderRadius: "12px",
                    padding: "20px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    textAlign: "center",
                    width: "100%",
                    minWidth: "350px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {/* Header Section */}
                  <div
                    style={{
                      background: "#4A4A5C",
                      color: "white",
                      padding: "16px",
                      fontSize: "24px",
                      fontWeight: "bold",
                      position: "absolute",
                      width: "100%",
                      borderTopLeftRadius: "12px",
                      borderTopRightRadius: "12px",
                      textAlign: "center",
                      top: "0",
                      left: "0",
                      right: "0",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "white",
                      }}
                    >
                      Sold/Connected
                    </div>
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "5px",
                      }}
                    >
                      {salesVsConnected.total_sales} / {salesVsConnected.total_connected}
                    </div>
                    {/* <div
                                            style={{
                                                marginTop: "5px",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                color: "#28a745",
                                            }}
                                        >
                                            ▲ 5%
                                        </div> */}

                    {/* Progress Bar */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center", // Center the bar horizontally
                        alignItems: "center", // Align items in the center
                        marginTop: "8px",
                        width: "100%", // Ensure it spans the full width
                      }}
                    >
                      <div
                        style={{
                          width: "80%", // Adjust width as needed
                          height: "8px",
                          background: "#e9ecef",
                          borderRadius: "4px",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            width: `${salesVsConnected.sales_vs_connected_per}%`, // Match the progress percentage
                            height: "100%",
                            background: "#5BA317",
                            borderRadius: "4px",
                          }}
                        ></div>
                      </div>
                    </div>

                    {/* Percentage Label */}
                    <div
                      style={{
                        textAlign: "start",
                        marginTop: "5px",
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "#5BA317",
                        marginLeft: "45px",
                      }}
                    >
                      {salesVsConnected.sales_vs_connected_per}%
                    </div>
                  </div>

                  {/* Graph Section */}
                  <div
                    style={{
                      marginTop: "200px",
                      width: "100%",
                      position: "relative",
                    }}
                  >
                    {" "}
                    {/* Added margin to avoid overlap */}
                    <ResponsiveContainer width="100%" height={350}>
                      <BarChart data={salesVsConnected.results} barSize={10}>
                        <XAxis
                          dataKey="label"
                          tick={{
                            fill: "#6c757d",
                            fontSize: 14,
                            fontWeight: "bold",
                          }}
                        />
                        <YAxis tick={{ fill: "#6c757d", fontSize: 12 }} />
                        <Tooltip />
                        <Legend
                          iconType="circle"
                          wrapperStyle={{
                            fontSize: 14,
                            fontWeight: "bold",
                            color: "#6c757d",
                          }}
                        />
                        <Bar
                          dataKey="connected"
                          fill="#34303D"

                          radius={[5, 5, 0, 0]}
                        />
                        <Bar
                          dataKey="sales"
                          fill="#4CAF50"
                          radius={[5, 5, 0, 0]}
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <div
                  // key={index}
                  style={{
                    background: "white",
                    borderRadius: "12px",
                    padding: "20px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    textAlign: "center",
                    width: "100%",
                    minWidth: "350px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {/* Header Section */}
                  <div
                    style={{
                      background: "#4A4A5C",
                      color: "white",
                      padding: "16px",
                      fontSize: "24px",
                      fontWeight: "bold",
                      position: "absolute",
                      width: "100%",
                      borderTopLeftRadius: "12px",
                      borderTopRightRadius: "12px",
                      textAlign: "center",
                      top: "0",
                      left: "0",
                      right: "0",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "white",
                      }}
                    >
                      Sold/Call Back
                    </div>
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "5px",
                      }}
                    >
                      {salesVsCallBack.total_sales}/{salesVsCallBack.total_call_backs}
                    </div>
                    {/* <div
                                            style={{
                                                marginTop: "5px",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                color: "#28a745",
                                            }}
                                        >
                                            ▲ 5%
                                        </div> */}

                    {/* Progress Bar */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center", // Center the bar horizontally
                        alignItems: "center", // Align items in the center
                        marginTop: "8px",
                        width: "100%", // Ensure it spans the full width
                      }}
                    >
                      <div
                        style={{
                          width: "80%", // Adjust width as needed
                          height: "8px",
                          background: "#e9ecef",
                          borderRadius: "4px",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            width: `${salesVsCallBack.sales_vs_call_backs_per}%`, // Match the progress percentage
                            height: "100%",
                            background: "#5BA317",
                            borderRadius: "4px",
                          }}
                        ></div>
                      </div>
                    </div>

                    {/* Percentage Label */}
                    <div
                      style={{
                        textAlign: "start",
                        marginTop: "5px",
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "#5BA317",
                        marginLeft: "45px",
                      }}
                    >
                      {salesVsCallBack.sales_vs_call_backs_per}%
                    </div>
                  </div>

                  {/* Graph Section */}
                  <div
                    style={{
                      marginTop: "200px",
                      width: "100%",
                      position: "relative",
                    }}
                  >
                    {" "}
                    {/* Added margin to avoid overlap */}
                    <ResponsiveContainer width="100%" height={350}>
                      <BarChart data={salesVsCallBack.results} barSize={10}>
                        <XAxis
                          dataKey="label"
                          tick={{
                            fill: "#6c757d",
                            fontSize: 14,
                            fontWeight: "bold",
                          }}
                        />
                        <YAxis tick={{ fill: "#6c757d", fontSize: 12 }} />
                        <Tooltip />
                        <Legend
                          iconType="circle"
                          wrapperStyle={{
                            fontSize: 14,
                            fontWeight: "bold",
                            color: "#6c757d",
                          }}
                        />
                        <Bar
                          dataKey="call_backs"
                          fill="#34303D"

                          radius={[5, 5, 0, 0]}
                        />
                        <Bar
                          dataKey="sales"
                          fill="#4CAF50"
                          radius={[5, 5, 0, 0]}
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <div
                  // key={index}
                  style={{
                    background: "white",
                    borderRadius: "12px",
                    padding: "20px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    textAlign: "center",
                    width: "100%",
                    minWidth: "350px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {/* Header Section */}
                  <div
                    style={{
                      background: "#4A4A5C",
                      color: "white",
                      padding: "16px",
                      fontSize: "24px",
                      fontWeight: "bold",
                      position: "absolute",
                      width: "100%",
                      borderTopLeftRadius: "12px",
                      borderTopRightRadius: "12px",
                      textAlign: "center",
                      top: "0",
                      left: "0",
                      right: "0",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "white",
                      }}
                    >
                      Sold/Intrested
                    </div>
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "5px",
                      }}
                    >
                      {salesVsIntrested.total_sales}/{salesVsIntrested.total_interested}
                    </div>
                    {/* <div
                                            style={{
                                                marginTop: "5px",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                color: "#28a745",
                                            }}
                                        >
                                            ▲ 5%
                                        </div> */}

                    {/* Progress Bar */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center", // Center the bar horizontally
                        alignItems: "center", // Align items in the center
                        marginTop: "8px",
                        width: "100%", // Ensure it spans the full width
                      }}
                    >
                      <div
                        style={{
                          width: "80%", // Adjust width as needed
                          height: "8px",
                          background: "#e9ecef",
                          borderRadius: "4px",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            width: `${salesVsIntrested.sales_vs_interested_per}%`, // Match the progress percentage
                            height: "100%",
                            background: "#5BA317",
                            borderRadius: "4px",
                          }}
                        ></div>
                      </div>
                    </div>

                    {/* Percentage Label */}
                    <div
                      style={{
                        textAlign: "start",
                        marginTop: "5px",
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "#5BA317",
                        marginLeft: "45px",
                      }}
                    >
                      {salesVsIntrested.sales_vs_interested_per}%
                    </div>
                  </div>

                  {/* Graph Section */}
                  <div
                    style={{
                      marginTop: "200px",
                      width: "100%",
                      position: "relative",
                    }}
                  >
                    {" "}
                    {/* Added margin to avoid overlap */}
                    <ResponsiveContainer width="100%" height={350}>
                      <BarChart data={salesVsIntrested.results} barSize={10}>
                        <XAxis
                          dataKey="label"
                          tick={{
                            fill: "#6c757d",
                            fontSize: 14,
                            fontWeight: "bold",
                          }}
                        />
                        <YAxis tick={{ fill: "#6c757d", fontSize: 12 }} />
                        <Tooltip />
                        <Legend
                          iconType="circle"
                          wrapperStyle={{
                            fontSize: 14,
                            fontWeight: "bold",
                            color: "#6c757d",
                          }}
                        />
                        <Bar
                          dataKey="interested"
                          fill="#34303D"
                          radius={[5, 5, 0, 0]}
                        />
                        <Bar
                          dataKey="sales"
                          fill="#4CAF50"

                          radius={[5, 5, 0, 0]}
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>

                {/* ))} */}
              </div>
              {/* <div
                style={{
                  // display: "grid",
                  // gridTemplateColumns: "repeat(13, 1fr)",
                  gap: "16px",
                  padding: "16px",
                }}
              >
                <div
                  style={{
                    gridColumn: "span 4",
                    width: "34rem",
                    padding: "1rem",
                    borderRadius: "1rem",
                    backgroundColor: "#E4C2ED",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                    // margin: "13px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      position: "relative",
                      width: "100%",
                      height: "25rem",
                      backgroundColor: "#A82AC8",
                      borderRadius: "1rem", // Keeps the top rounded
                      padding: "1rem",
                      clipPath:
                        "polygon(0% 0%, 100% 0%, 100% 70%, 50% 100%, 0% 70%)",
                    }}
                  >
                    <h1 style={{ color: "white", marginBottom: "1rem" }}>
                      Leader Board
                    </h1>
                    {winners.slice(0, 3).map((winner, index) => {
                      let positionStyles = {};
                      if (index === 0) {
                        positionStyles = {
                          top: "3.5rem",
                          left: "50%",
                          transform: "translateX(-50%)",
                        };
                      } else if (index === 1) {
                        positionStyles = {
                          top: "9.5rem",
                          left: "25%",
                          transform: "translateX(-50%)",
                        };
                      } else if (index === 2) {
                        positionStyles = {
                          top: "9.5rem",
                          left: "75%",
                          transform: "translateX(-50%)",
                        };
                      }
                      return (
                        <div
                          key={winner.rank}
                          style={{
                            position: "absolute",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            ...positionStyles,
                          }}
                        >
                          <img
                            src={winner.image}
                            alt={winner.name}
                            style={{
                              width: "5rem",
                              height: "5rem",
                              borderRadius: "50%",
                            }}
                          />
                          <p
                            style={{
                              marginTop: "0.5rem",
                              fontWeight: "bold",
                              fontSize: "1.125rem",
                              color: "white",
                            }}
                          >
                            {winner.name} ({winner.rank})
                          </p>
                        </div>
                      );
                    })}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "100%",
                      marginTop: "9px",
                    }}
                  >
                    {winners.slice(3).map((winner) => (
                      <div
                        key={winner.rank}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#fff",
                          borderRadius: "1rem",
                          padding: "0.75rem 1.5rem",
                          marginBottom: "0.5rem",
                          width: "90%",
                          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                          fontWeight: "bold",
                          fontSize: "1.25rem",
                          height: "59px",
                        }}
                      >
                        <p style={{ marginRight: "1rem", marginTop: "13px" }}>
                          {winner.rank}
                        </p>
                        <img
                          src={winner.image}
                          alt={winner.name}
                          style={{
                            width: "3.5rem",
                            height: "3.5rem",
                            borderRadius: "50%",
                            border: "2px solid white",
                            marginRight: "1rem",
                          }}
                        />
                        <p style={{ flexGrow: 1, marginTop: "13px" }}>
                          {winner.name}
                        </p>
                        <p style={{ marginRight: "1rem", marginTop: "13px" }}>
                          {winner.score}
                        </p>
                        <span style={{ color: "green" }}>▲</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div> */}
            </div>
          </>
        </div>
        {/* <div>
          <div
            style={{
              position: "fixed" as "fixed",
              bottom: "10px",
              right: "10px",
              display: "flex",
              flexDirection: "column" as "column",
              gap: "10px",
              // backgroundColor: "rgba(255, 255, 255, 0.8)", // Optional: Add background for better visibility
              borderRadius: "8px", // Optional: Rounded corners
              padding: "10px",
            }}
          >
            {checkPermission("view_script", "script") && (
              <img
                src="assets\img\podium_11543322.png"
                alt="Chat Script"
                title="Chat Script"
                style={{
                  width: "69px",
                  height: "69px",
                  cursor: "pointer",
                  marginBottom: "10px",
                }}
                onClick={toggleCard}
              />
            )}
          </div>
          <div
            style={{
              padding: "1rem",
              borderRadius: "1rem",
              backgroundColor: "#A82AC8",
              clipPath: "polygon(0% 0%, 100% 0%, 100% 70%, 50% 100%, 0% 70%)",
            }}
          >
            <h1 style={{ color: "white", marginBottom: "1rem" }}>
              Leader Board
            </h1>
            {winners.slice(0, 3).map((winner, index) => {
              let positionStyles = {};
              if (index === 0) {
                positionStyles = {
                  top: "3.5rem",
                  left: "50%",
                  transform: "translateX(-50%)",
                };
              } else if (index === 1) {
                positionStyles = {
                  top: "9.5rem",
                  left: "25%",
                  transform: "translateX(-50%)",
                };
              } else if (index === 2) {
                positionStyles = {
                  top: "9.5rem",
                  left: "75%",
                  transform: "translateX(-50%)",
                };
              }
              return (
                <div
                  key={winner.rank}
                  style={{
                    position: "absolute",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    ...positionStyles,
                  }}
                >
                  <img
                    src={winner.image}
                    alt={winner.name}
                    style={{
                      width: "5rem",
                      height: "5rem",
                      borderRadius: "50%",
                    }}
                  />
                  <p
                    style={{
                      marginTop: "0.5rem",
                      fontWeight: "bold",
                      fontSize: "1.125rem",
                      color: "white",
                    }}
                  >
                    {winner.name} ({winner.rank})
                  </p>
                </div>
              );
            })}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              marginTop: "9px",
            }}
          >
            {winners.slice(3).map((winner) => (
              <div
                key={winner.rank}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#fff",
                  borderRadius: "1rem",
                  padding: "0.75rem 1.5rem",
                  marginBottom: "0.5rem",
                  width: "90%",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  fontWeight: "bold",
                  fontSize: "1.25rem",
                  height: "59px",
                }}
              >
                <p style={{ marginRight: "1rem", marginTop: "13px" }}>
                  {winner.rank}
                </p>
                <img
                  src={winner.image}
                  alt={winner.name}
                  style={{
                    width: "3.5rem",
                    height: "3.5rem",
                    borderRadius: "50%",
                    border: "2px solid white",
                    marginRight: "1rem",
                  }}
                />
                <p style={{ flexGrow: 1, marginTop: "13px" }}>{winner.name}</p>
                <p style={{ marginRight: "1rem", marginTop: "13px" }}>
                  {winner.score}
                </p>
                <span style={{ color: "green" }}>▲</span>
              </div>
            ))}
          </div>
        </div> */}
        <div>
          {/* Icon to toggle the leaderboard */}
          <div
            style={{
              position: "fixed",
              bottom: "10px",
              right: "4px",
              zIndex: 2000, // Ensure the icon is above the leaderboard
            }}
          >
            {!isOpen && (
              <img
                src="/assets/img/podium_11543322.png"
                alt="Leaderboard"
                title="Leaderboard"

                style={{
                  width: "49px",
                  height: "49px",
                  cursor: "pointer",
                  marginBottom: "10px",
                }}
                onClick={toggleCard}
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRight"
                aria-controls="offcanvasRight"
              />
            )}
          </div>
          <div
            className="offcanvas offcanvas-end"
            tabIndex={-1}
            id="offcanvasRight"
            aria-labelledby="offcanvasRightLabel"
            style={{ maxWidth: "29%", background: 'linear-gradient(0deg, white 0%, #DFE3FF 100%)' }}
          >
            <div
              className="offcanvas-header"
              style={{
                textAlign: "center",
                padding: "1rem",
                // borderBottom: "2px solid #EEF1FF",
              }}
            >
              <div>
                <h1
                  style={{
                    color: "#364D9B",
                  }}
                >
                  Leader Board
                </h1>
              </div>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                onClick={toggleCard}
              />
            </div>{" "}
            {/* end offcanvas-header*/}
            <div className="offcanvas-body">
              <div>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-around',
                  alignItems: 'flex-end',
                  padding: '10px',
                  height: '300px',
                  position: 'relative',
                  marginTop: "15px"
                }}>
                  {reorderedTop3.map((barImage, index) => {
                    let translateY = '0px'; // Default position

                    if (index === 0) {
                      translateY = '-5px'; // Move the first bar slightly down
                    } else if (index === 2) {
                      translateY = '-10px'; // Move the third bar slightly up
                    }

                    return (
                      <div key={index} style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: '5px',
                        position: 'relative',
                        transform: `translateY(${translateY})`,
                      }}>

                        <img
                          src={barImage.photo ? `${webApi}${barImage.photo}` : 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png'}
                          alt={`Profile ${index + 1}`}
                          style={{
                            marginBottom: '10px',
                            borderRadius: '50%',
                            width: '70px',
                            height: '70px',
                          }}
                        />
                        <div style={{ position: 'relative', width: '100px', height: 'auto' }}>
                          <img
                            src={barImages[index]} // Replace with actual bar image source
                            alt={`Bar ${index + 1}`}
                            style={{
                              width: '100%',
                              height: 'auto',
                            }}
                          />
                          <div style={{
                            position: 'absolute',
                            top: '40%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            // color: 'white',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            fontSize: '0.8rem',
                          }}>
                            <div style={{
                              width: '30px',
                              height: '30px',
                              borderRadius: '50%',
                              backgroundColor: 'white',
                              // border: '2px solid black',
                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              margin: '0 auto',
                            }}>{barImage.sl_no}</div>
                            <div style={{
                              color: "white",
                              width: '70px',
                              whiteSpace: 'normal',
                              wordWrap: 'break-word',
                              overflowWrap: 'break-word'
                            }}>
                              {barImage.username}
                            </div>

                            <div style={{ color: "white" }}>{barImage.sales_count}</div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Tabs Section */}
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-around',
                  marginTop: '20px',
                }}>
                  {['Today', 'Last 7 days', 'Last 30 days', 'AllTime'].map((tab, index) => (
                    <div key={index} style={{
                      padding: '10px 20px',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      textAlign: 'center',
                      transition: 'background-color 0.3s',
                    }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e0e0e0'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                      onClick={() => {
                        const mappedTab = tabMapping[tab]; // Convert label to correct tab key
                        setActiveTab(mappedTab); // Set correct tab key
                      }}>
                      {tab}
                    </div>
                  ))}
                </div>

                {/* Display Data Based on Active Tab */}
                <div style={{ marginTop: '20px' }}>
                  {others.map((item) => (
                    <div key={item.id} style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      margin: '0 auto',
                      marginBottom: '10px',
                      color: '#3D4E9B',
                      fontWeight: "bold",
                      fontSize: "1rem",
                      width: '85%'
                    }}>
                      <span style={{ flex: 1, textAlign: 'left' }}>{item.sl_no}</span>
                      <img
                        src={item.photo ? `${webApi}${item.photo}` : 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png'}
                        alt={`Profile of ${item.username}`}
                        style={{
                          margin: '0 5px 0 -50px',
                          borderRadius: '50%',
                          width: '50px',
                          height: '50px',
                          alignItems: 'start',
                        }}
                      />
                      <span style={{
                        flex: 1, textAlign: 'center', marginLeft: "5px", width: '70px',
                        whiteSpace: 'normal',
                        wordWrap: 'break-word',
                        overflowWrap: 'break-word'
                      }}>{item.username}</span>
                      <span style={{ flex: 1, textAlign: 'right' }}>{item.sales_count}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>{" "}
            {/* end offcanvas-body*/}
          </div>{" "}
          {/* Leaderboard overlay */}
        </div>
        {/* <LeaderBoard />  */}
      </div>
      {/* /Page Wrapper */}
      <AdminDashboardModal />
    </>
  );
};

export default AdminDashboard;
